// Object を走査し、入力率を判定する
// 戻り値は、小数点第三位以下を切り捨て
export const calcInputRate = (values: object): number | undefined => {
  try {
    const [inputCount, totalCount] = countInput(values);
    const inputRate = (Number(inputCount) / Number(totalCount)) * 100;
    return isNaN(inputRate) ? 0 : Math.floor(inputRate * 100) / 100;
  } catch (e: unknown) {
    return undefined;
  }
};

const countInput = (values: object): number[] => {
  // [入力されている input 数, 総 input 数] を値として扱う
  return Object.values(values).reduce(
    (previousValue: number[], currentValue) => {
      const previousInputCount = Number(previousValue[0]);
      const previousTotalCount = Number(previousValue[1]);

      if (isObject(currentValue)) {
        const [inputCount, totalCount]: number[] = countInput(currentValue);
        return [previousInputCount + Number(inputCount), previousTotalCount + Number(totalCount)];
      }

      if (currentValue === null || currentValue === undefined || currentValue === "") {
        return [previousInputCount, previousTotalCount + 1];
      } else {
        return [previousInputCount + 1, previousTotalCount + 1];
      }
    },
    [0, 0],
  );
};

const isObject = (value: unknown): boolean => {
  return value !== null && !Array.isArray(value) && typeof value === "object";
};
